// 验证是否为空
function isNull(val) {
	if (val == '' || val == undefined || val == null || JSON.stringify(val) == '{}') return false;
	return true;
}
// 验证手机号码
function isPhone(val) {
	if (!/^[1][3,4,5,6,7,8,9][0-9]{9}$/.test(val)) return false;
	return true;
}
// 验证邮箱
function isEmail(val) {
    if (!/^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/.test(val)) return false;
    return true;
}
// 验证身份证
function isIDCard(val, birthVal) {
    var num = val.toUpperCase();
    //身份证号码为15位或者18位，15位时全为数字，18位前17位为数字，最后一位是校验位，可能为数字或字符X。   
    if (!(/(^\d{15}$)|(^\d{17}([0-9]|X)$)/.test(num))) {
        console.log('输入的身份证号长度不对，或者号码不符合规定！\n15位号码应全为数字，18位号码末位可以为数字或X。');
        return false;
    }
    //校验位按照ISO 7064:1983.MOD 11-2的规定生成，X可以认为是数字10。 
    //下面分别分析出生日期和校验位 
    var len, re;
    len = num.length;
    if (len == 15) {
        re = new RegExp(/^(\d{6})(\d{2})(\d{2})(\d{2})(\d{3})$/);
        var arrSplit = num.match(re);
        //检查生日日期是否正确 
        var dtmBirth = new Date('19' + arrSplit[2] + '/' + arrSplit[3] + '/' + arrSplit[4]);
        var bGoodDay;
        bGoodDay = (dtmBirth.getYear() == Number(arrSplit[2])) && ((dtmBirth.getMonth() + 1) == Number(arrSplit[3])) && (dtmBirth.getDate() == Number(arrSplit[4]));
        if (!bGoodDay) {
            console.log('输入的身份证号里出生日期不对！');
            return false;
        } else {
            //将15位身份证转成18位 
            //校验位按照ISO 7064:1983.MOD 11-2的规定生成，X可以认为是数字10。 
            var arrInt = new Array(7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2);
            var arrCh = new Array('1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2');
            var nTemp = 0, i;
            num = num.substr(0, 6) + '19' + num.substr(6, num.length - 6);
            for (i = 0; i < 17; i++) {
                nTemp += num.substr(i, 1) * arrInt[i];
            }
            num += arrCh[nTemp % 11];
            return true;
        }
    }
    if (len == 18) {
        re = new RegExp(/^(\d{6})(\d{4})(\d{2})(\d{2})(\d{3})([0-9]|X)$/);
        var arrSplit = num.match(re);
        //检查生日日期是否正确 
        var dtmBirth = new Date(arrSplit[2] + "/" + arrSplit[3] + "/" + arrSplit[4]);
        var bGoodDay;
        bGoodDay = (dtmBirth.getFullYear() == Number(arrSplit[2])) && ((dtmBirth.getMonth() + 1) == Number(arrSplit[3])) && (dtmBirth.getDate() == Number(arrSplit[4]));
        if (!bGoodDay) {
            console.log('输入的身份证号里出生日期不对！');
            return false;
        } else {
            //根据传入的出生日期判断身份证中的出生日期是否正确
            var birthDay = arrSplit[2] + "-" + arrSplit[3] + "-" + arrSplit[4];
            //格式化传入的出生日期
            if (birthVal !== null) {
                birthVal = moment(birthVal).format('YYYY-MM-DD');
            }
            if(birthVal != null && birthDay != birthVal) return false;
            //检验18位身份证的校验码是否正确。 
            //校验位按照ISO 7064:1983.MOD 11-2的规定生成，X可以认为是数字10。 
            var valnum;
            var arrInt = new Array(7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2);
            var arrCh = new Array("1", "0", "X", "9", "8", "7", "6", "5", "4", "3", "2");
            var nTemp = 0, i;
            for (i = 0; i < 17; i++) {
                nTemp += num.substr(i, 1) * arrInt[i];
            }
            valnum = arrCh[nTemp % 11];
            if (valnum != num.substr(17, 1)) {
                console.log('身份证格式不正确！最后一位应该是：' + valnum);
                return false;
            }
            return true;
        }
    }
    return false;
  }
  import moment from 'moment';
  export default {
    checkNull(value) {
        return isNull(value);
    },
    checkPhone(value) {
      return isPhone(value);
    },
    checkEmail(value) {
      return isEmail(value);
    },
    checkIDCard(value, birthVal) {
      return isIDCard(value, birthVal);
    },
  }